import { connect } from "react-redux";

import { actions } from "features/Model/_ducks";

import Checklist from "./";

const { updateChecklistItem } = actions;

const mapStateToProps = ({ model: { checklist: { list = {} } = {} } }) => {
    return {
        list,
    };
};

const mapDispatchToProps = (dispatch) => ({
    updateChecklistItem: (id, updates) => dispatch(updateChecklistItem(id, updates)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Checklist);
